<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-bind="$attrs"
    class="safe-padding flex items-center justify-center"
    :content-class="`modal-box bg-white rounded-lg w-[calc(100vw_-_2rem)] max-w-5xl ${isFullScreen ? 'h-full' : ''} ${contentClass}`"
    content-transition="vfm-fade"
    overlay-transition="vfm-fade"
    :click-to-close="closeOnClickOutside"
    :esc-to-close="closeOnEscapeKey"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div
      v-if="$slots.title || showClose"
      class="mb-4 flex items-center gap-2"
      :class="{ 'justify-end': !$slots.title }"
    >
      <h2 v-if="$slots.title" class="min-w-0 flex-1">
        <slot name="title"></slot>
      </h2>
      <button
        v-if="showClose"
        size="icon"
        class="shrink-0 p-1 text-obsidian-800 transition hover:text-obsidian-600"
        data-testid="close-modal"
        @click="$emit('update:modelValue', false)"
      >
        <XIcon class="size-5" />
      </button>
    </div>
    <div :class="isFullScreen ? 'h-full' : 'flex-grow'">
      <slot :params="params"></slot>
    </div>
    <div
      v-if="showConfirm || showCancel"
      class="flex flex-shrink-0 items-center justify-center pt-4"
    >
      <CVButton v-if="showConfirm" @click="$emit('confirm', close)">
        {{ t('confirm') }}
      </CVButton>
      <CVButton v-if="showCancel" @click="$emit('cancel', close)">
        {{ t('cancel') }}
      </CVButton>
    </div>
  </vue-final-modal>
</template>

<script lang="ts">
// use normal <script> to declare options
export default {
  inheritAttrs: false,
};
</script>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import CVButton from './buttons/CVButton.vue';
import { XIcon } from 'lucide-vue-next';

const { t } = useI18n();

withDefaults(
  defineProps<{
    showConfirm?: boolean;
    showClose?: boolean;
    showCancel?: boolean;
    closeOnClickOutside?: boolean;
    closeOnEscapeKey?: boolean;
    isFullScreen?: boolean;
    contentClass?: string;
  }>(),
  {
    closeOnClickOutside: true,
    closeOnEscapeKey: true,
    isFullScreen: false,
  },
);

defineEmits<{
  (e: 'confirm', close: () => void): void;
  (e: 'cancel', close: () => void): void;
  (e: 'update:modelValue', value: boolean): void;
}>();
</script>
